// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__wxA8A","redTheme":"styles_redTheme__Rx9Iv"};